import React, { useState } from 'react';
import { Formik, Form, Field } from 'formik';
import { useHistory } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { isEmpty } from 'lodash';
import Auth from '../../components/Auth/Auth';
import {
  fetchUserSecurityQuestion,
  postPasswordForgottenRequest,
} from '../../store/actions/user/userActions';
import {
  RESET_SECURITY_QUESTION_PAGE,
  RESET_SENT_PAGE,
  TWO_FA_FORGOT_PASSWORD_IDENTITY_PAGE,
  TWO_FA_FORGOT_PASSWORD_IDENTITY_PHONE_PAGE,
} from '../../constants/pages';
import AuthCard from '../../components/Auth/AuthCard';
import AuthButtons from '../../components/Auth/AuthButtons';
import FormContainer from '../../components/FormContainer/FormContainer';
import SectionLoader from '../../components/Loader/SectionLoader';
import TextField from '../../components/InputFields/TextField';
import { selectSettings } from '../../store/selectors/settingsSelectors';
import { storeInSessionStorage } from '../../util/helpers/sessionStorageHelper';
import { fetchTwoFa } from '../../store/actions/twoFA/twoFAActions';
import { userForgotPasswordSchema } from '../../validation/userLoginValidationSchema';
import Note from '../../components/Notes/Note';
import SupportModal from '../../components/Modals/SupportModal/SupportModal';
import Paragraph from '../../components/Paragraph/Paragraph';

const ForgotPasswordPage = () => {
  const brokerSettings = useSelector(selectSettings);
  const { t } = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
  const { IsBroker2FAActive } = brokerSettings;
  const [isLoading, setIsLoading] = useState(false);
  const [forgotPasswordError, setForgotPasswordError] = useState('');
  const [isSupportModalOpen, setSupportModalOpen] = useState(false);

  // const isLoading = useSelector(
  //   selectIsLoadingByActionTypes([
  //     GET_TWO_FA_LOADING,
  //     PASSWORD_FORGOTTEN_REQUEST_LOADING,
  //   ]),
  // );

  const handleSubmit = (values, { setFieldError }) => {
    const { username } = values;

    // if (!username) {
    //   const errorMessage = t('validationSchema.general.usernameRequired');
    //   setFieldError('username', errorMessage);
    //   setForgotPasswordError(errorMessage);
    //   return;
    // }

    // setForgotPasswordError('');

    const encodedUsername = encodeURIComponent(username);

    const resetPasswordSent = () => {
      dispatch(
        postPasswordForgottenRequest({
          data: {
            Username: username,
          },
          handleSuccess: () => {
            history.push(RESET_SENT_PAGE);
          },
          handleError: (error) => {
            const errorCode = error?.response?.data?.Errors[0]?.Code;
            const errorMessage = error?.response?.data?.Errors[0]?.Message;

            if (errorCode === 'UserNotFound') {
              history.push(RESET_SENT_PAGE); // Proceed anyway acording to requirements (58845)
            } else {
              setForgotPasswordError(errorMessage);
            }
          },
          setFieldError,
          setIsLoading,
        }),
      );
    };

    const onSuccessfulTwoFaFetch = (value) => {
      const onSuccessfullSecurityQuestionFetch = () =>
        // if (value) {
        //   return history.push(
        //     `${RESET_SECURITY_QUESTION_PAGE}?username=${encodedUsername}`,
        //   );
        // }

        resetPasswordSent();
      if (!isEmpty(value) && IsBroker2FAActive) {
        const { AuthenticationMethodType } = value;
        storeInSessionStorage('ForgotPasswordUsername', encodedUsername);

        if (AuthenticationMethodType === 2) {
          history.push(
            `${TWO_FA_FORGOT_PASSWORD_IDENTITY_PHONE_PAGE}?username=${encodedUsername}`,
          );
          return;
        }

        history.push(
          `${TWO_FA_FORGOT_PASSWORD_IDENTITY_PAGE}?username=${encodedUsername}`,
        );
        return;
      }
      dispatch(
        fetchUserSecurityQuestion({
          username,
          onSuccessfullSecurityQuestionFetch,
        }),
      );
    };

    if (IsBroker2FAActive) {
      dispatch(fetchTwoFa({ username, onSuccessfulTwoFaFetch }));
    } else {
      history.push(
        `${RESET_SECURITY_QUESTION_PAGE}?username=${encodedUsername}`,
      );
    }
  };

  return (
    <SectionLoader isLoading={isLoading}>
      <Auth>
        <AuthCard
          title={t('login.forgotPassword.title')}
          subtitle={t('login.forgotPassword.subtitle')}
        >
          <Formik
            initialValues={{ username: '' }}
            onSubmit={handleSubmit}
            validationSchema={userForgotPasswordSchema}
            validateOnBlur={false}
            enableReinitialize
          >
            {({ values, setFieldError, setFieldValue }) => (
              <Form>
                <FormContainer>
                  <Field
                    label={t('login.fields.emailOrUsername')}
                    name="username"
                    component={TextField}
                    autoFocus
                    data-cy="input-username"
                    onChange={(e) => {
                      const { value } = e.target;
                      setFieldValue('username', value);

                      if (forgotPasswordError) {
                        setForgotPasswordError('');
                        setFieldError('username', '');
                      }
                    }}
                  />
                </FormContainer>
                <AuthButtons
                  showOnlyPrimary
                  primaryButtonProps={{
                    label: t('login.forgotPassword.sendResetLinkButton'),
                    disabled: !values.username,
                    type: 'submit',
                    textTransform: 'capitalize',
                  }}
                />
              </Form>
            )}
          </Formik>
          <Paragraph marginTop={20} fontSize={16}>
            {t('login.forgotPassword.needHelp')}
            <Note
              primaryColor
              bold
              text={t('login.forgotPassword.contactSupport')}
              onClick={(event) => {
                event.preventDefault();
                event.stopPropagation();
                setSupportModalOpen(true);
              }}
            />
          </Paragraph>
        </AuthCard>
      </Auth>
      <SupportModal
        handleOutsideClick
        isOpen={isSupportModalOpen}
        close={setSupportModalOpen}
      />
    </SectionLoader>
  );
};

export default ForgotPasswordPage;
